import { useDevToolsStore } from '../store/useDevToolsStore';
import { computed } from 'vue';

/**
 * Composable for debug logging that respects the DevTools debug mode setting
 * Use this within Vue component setup functions
 */
export function useDebugLogger() {
  const devToolsStore = useDevToolsStore();

  // Use computed for better reactivity
  const isDebugEnabled = computed(() => {
    // Set global flag for non-Vue contexts
    if (typeof window !== 'undefined') {
      (window as any).DP3_DEBUG = devToolsStore.featureFlags.debugMode;
    }
    return devToolsStore.featureFlags.debugMode;
  });

  return {
    log(...args: any[]): void {
      if (isDebugEnabled.value) {
        console.log(...args);
      }
    },

    warn(...args: any[]): void {
      if (isDebugEnabled.value) {
        console.warn(...args);
      }
    },

    error(...args: any[]): void {
      if (isDebugEnabled.value) {
        console.error(...args);
      }
    },

    info(...args: any[]): void {
      if (isDebugEnabled.value) {
        console.info(...args);
      }
    },

    isEnabled: isDebugEnabled,
  };
}
